module.exports = __webpack_public_path__ + "static/img/taxcellent_content.4fca5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/taxcellent_content.png
// module id = Oo9r
// module chunks = 34